import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { FC, PropsWithChildren } from 'react';
import { CfCloseButton } from '../../buttons/CfCloseButton';
import { CfMenuItemPrefix } from '../../Menu/MenuItem/CfMenuItemPrefix';

export type CfDrawerHeaderProps = {
  iconClassName?: string;
  onClose?: () => void;
  closeButtonTestId?: string;
  displayDivider?: boolean;
  sx?: SxProps<Theme>;
  closeButtonSx?: SxProps<Theme>;
};

/**
 * The header component for drawers
 *
 * @param iconClassName - The icon to be used's class name
 * @param onClose - Method to call on click of the header close button
 * @param closeButtonTestId - Test id of the close button
 * @param displayDivider - Boolean indicating if the bottom divider should be displayed
 * @param sx - Additional styling for the header box
 * @param closeButtonSx - Styling for the header close button
 * @param children - Items to show in the footer
 */
export const CfDrawerHeader: FC<PropsWithChildren<CfDrawerHeaderProps>> = (
  props: PropsWithChildren<CfDrawerHeaderProps>
) => {
  return (
    <Box
      sx={{
        py: 2,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        typography: 'mobileLabel',
        color: (theme) => theme.palette.coolGrey[400],
        borderBottom: (theme) => (props.displayDivider ? `1px solid ${theme.palette.grey[50]}` : ''),
        ...props.sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {props.iconClassName && <CfMenuItemPrefix iconClassName={props.iconClassName} />}
        {props.children}
      </Box>
      {props.onClose && (
        <CfCloseButton
          onClick={props.onClose}
          variant='thick'
          dataTestId={props.closeButtonTestId}
          size='medium'
          sx={props.closeButtonSx ?? { color: 'inherit', p: 0 }}
        />
      )}
    </Box>
  );
};
